import axios from "axios";
import { protocol, url } from "../Urls";

export const saveMessage = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "post",
      baseURL: `${protocol}${url}`,
      url: "/saveMessage",
      data: data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getMessages = (data) => {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        method: "post",
        baseURL: `${protocol}${url}`,
        url: "/getMessages",
        data: data,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };